import { en, type Messages } from './locales/en';

/**
 * The active message catalog. Import this anywhere user-facing text is needed:
 *
 *   import { t } from '@shared/i18n';
 *   <Label>{t.login.identifier.label}</Label>
 *
 * To add a language, create `./locales/<lang>.ts` typed as `Messages`, then select it here
 * (statically for now, or wire to a runtime locale/store later). Because every locale satisfies
 * the same `Messages` shape, all `t.*` usages stay type-safe and exhaustively checked.
 */
export const t: Messages = en;

export type { Messages };
